// extracted by mini-css-extract-plugin
module.exports = {"alertWidth":"style__alertWidth__UAQxi"};